(() => {
  angular.module('pims').filter('visitid', () => {
    return visitid => {
      if (!visitid) {
        return;
      }

      var VisitId = visitid.toString();
      var newVisitID = ""; // VisitId.forEach((s) => {
      //   newVisitID +=  s
      // });

      for (var i = 0; i < VisitId.length; i++) {
        newVisitID += VisitId.charAt(i);

        if (i / 2 == 1) {
          newVisitID += " ";
        }
      }

      return `${newVisitID}`;
    };
  });
})();